import { FPTI_TAGS, FPTI_VALUES } from '../../fpti/fptiConstants';
const analytics = window?.PAYPAL?.analytics?.instance;

// Start client side error tracking
window?.PAYPAL?.analytics?.startClientErrorTracking();

export const trackEventWithData = (spec = {}, additionalData = {}) => {
  const fptiData = {
    ...spec.data,
    ...additionalData,
    [FPTI_TAGS.SPACE_KEY]: FPTI_VALUES.SPACE_KEY_ID,
    [FPTI_TAGS.PRODUCT]: 'donate',
  };
  // ref: https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/docs/fptiAnalytics.Analytics.html#recordEvent
  // the 3rd param is set to false meaning the data payload won't be merged
  // with window.fpti object
  analytics?.recordEvent(spec.event_name, fptiData, false);
};

export const trackEventWithGlobalData = (spec = {}, additionalData = {}) => {
  const fptiData = {
    ...spec.data,
    ...additionalData,
    [FPTI_TAGS.SPACE_KEY]: FPTI_VALUES.SPACE_KEY_ID,
    [FPTI_TAGS.PRODUCT]: 'donate',
  };
  analytics?.recordEvent(spec.event_name, fptiData, true);
};
